import React from 'react';
import { Flex, Spacer, Box, Divider } from '@chakra-ui/react';
import BEPills from '@molecules/BEPills';

const DemoPills = () => {
  return (
    <Box>
      <h2>Pills</h2>
      <Divider m={2} />
      <Flex align={'center'} gap="12px">
        <p>Accommondation Attributes</p>
        <Spacer />
        <BEPills iconRight="user">2</BEPills>
        <BEPills iconRight="child-reaching">1</BEPills>
        <BEPills iconLeft="moon">2 Nights Min</BEPills>
        <BEPills iconRight="bed">4</BEPills>
      </Flex>
      <Divider m={2} />
      <Flex align={'center'} gap="12px">
        <p>Amenity</p>
        <Spacer />
        <BEPills skin="amenity">Amenity</BEPills>
        <BEPills iconLeft="24-hour-check-in" skin="amenity">
          Air Conditioner
        </BEPills>
      </Flex>
    </Box>
  );
};

export default DemoPills;
